export const colorsOptions = [
    {
        value: "#FFA07A",
        text: "Light Salmon"
    },
    {
        value: "#CD5C5C",
        text: "Indian Red"
    },
    {
        value: "#DC143C",
        text: "Crimson"
    },
    {
        value: "#20B2AA",
        text: "Light Sea Green"
    },
    {
        value: "#008B8B",
        text: "Dark Cyan"
    },
    {
        value: "#4682B4",
        text: "Steel Blue"
    }
]